<template>
  <div>
    <Header />
    <slot />
    <Footer />
  </div>
</template>